import script from "/app/packages/core/src/head/components/PageHead.vue?type=script"
export * from "/app/packages/core/src/head/components/PageHead.vue?type=script"
export default script